import { useCallback, useEffect, useState } from 'react';
import { document } from 'src/backend';
import useAuth from './useAuth';

export default function useDocuments() {
  const [types, setTypes] = useState([]);
  const [documents, setDocuments] = useState([]);
  const { user } = useAuth();

  useEffect(() => {
    document.getDocumentTypes().then((result) => setTypes(result));
  }, []);

  const fetchUserDocuments = useCallback(async () => {
    const myDocuments = await document.getUserDocuments(user?.id);
    setDocuments(myDocuments);
  }, [user]);

  return {
    documents,
    types,
    createDocument: async (data) => {
      return await document.createDocument(data);
    },
    getMyDocuments: fetchUserDocuments,
    deleteDocument: async (id) => {
      await document.deleteDocument(id);
      await fetchUserDocuments();
    },
  };
}
